import { render, staticRenderFns } from "./provincesRank.vue?vue&type=template&id=a55ebaec&scoped=true&lang=pug"
import script from "./provincesRank.vue?vue&type=script&lang=js"
export * from "./provincesRank.vue?vue&type=script&lang=js"
import style0 from "./provincesRank.vue?vue&type=style&index=0&id=a55ebaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55ebaec",
  null
  
)

export default component.exports